import React, { useEffect } from 'react';
import moment from 'moment/moment';
import { useForm, FormProvider, useWatch } from 'react-hook-form';
import { PartnerProposalTableFilters } from './types';
import { PartnerProposalsTableFilters } from './PartnerProposalsTableFilters';
import { PartnerProposalsDashboardTable } from './PartnerProposalsDashboardTable';
import { ProposalsPageButtonGroupOptions } from 'modules/aftermarketPartner/types';
import { useFetchProposals } from 'modules/aftermarketPartner/hooks/useFetchProposals';
import { tableDataAdapter } from './tableDataAdapter';
import { useTableManager } from './useTableManager';

interface Props {
  accountId: string;
  viewTab: ProposalsPageButtonGroupOptions;
}

export const PartnerProposalsTableContainer = ({ accountId, viewTab }: Props) => {
  const form = useForm<PartnerProposalTableFilters>({
    defaultValues: {
      filters: {
        status: 'all',
        dealType: 'all',
        to: moment().endOf('year'),
        from: moment().startOf('year'),
      },
    },
  });

  const filters = useWatch({ control: form.control, name: 'filters' });

  const { sorting, pagination, fetchVariables } = useTableManager(filters);
  const { proposals, total, isLoading } = useFetchProposals(accountId, viewTab, fetchVariables);

  const tableData = tableDataAdapter(proposals);

  useEffect(() => {
    form.reset();
  }, [viewTab]);

  return (
    <FormProvider {...form}>
      <PartnerProposalsTableFilters />
      <PartnerProposalsDashboardTable
        tableData={tableData}
        total={total}
        isLoading={isLoading}
        sorting={sorting}
        pagination={pagination}
      />
    </FormProvider>
  );
};
